import * as React from "react";
import { MUIDataTableMeta } from "mui-datatables";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import FileCopyIcon from "@material-ui/icons/FileCopy";
import { Trad } from "src/components";
import * as Dati from "src/Dati";
import * as Glob from "src/Globale";
import { _Button } from "../../components";

export const GetTendersDatabaseColumns = (useTendersDatabase: (data: Dati.CBancaDatiGare) => void) => [
    {
        name: "",
        label: "",
        options: {
            filter: false,
            sort: false,
            setCellProps: () => ({
                align: "center"
            }),
            customBodyRender: (val: string, tableMeta: MUIDataTableMeta) => {
                const rowData = { ...new Dati.CBancaDatiGare(), ...tableMeta.tableData[tableMeta.rowIndex] };
                return (
                    <Tooltip title={Trad.Trad("Utilizza")}>
                        <IconButton aria-label="edit" size="small" onClick={() => useTendersDatabase(rowData)}>
                            <FileCopyIcon />
                        </IconButton>
                    </Tooltip>
                );
            }
        }
    },
    {
        name: "ID_Anag",
        label: Trad.Trad("StessoID_Anag"),
        options: {
            filter: false,
            sort: false,
            setCellProps: () => ({
                align: "center"
            }),
            customBodyRender: (val: number) => (Glob.GetSessione().ID_Anag == val ? "Si" : "No")
        }
    },
    {
        name: "ID_Utente",
        label: Trad.Trad("StessoID_Utente"),
        options: {
            filter: false,
            sort: false,
            setCellProps: () => ({
                align: "center"
            }),
            customBodyRender: (val: number) => (Glob.GetSessione().ID_Utente == val ? "Si" : "No")
        }
    },
    {
        name: "CIG",
        label: Trad.Trad("CIG"),
        options: {
            filter: false,
            sort: false,
            setCellProps: () => ({
                align: "center"
            })
        }
    },
    {
        name: "NumeroUtilizzi",
        label: Trad.Trad("NumeroUtilizzi"),
        options: {
            filter: false,
            sort: false,
            setCellProps: () => ({
                align: "center"
            })
        }
    },
    {
        name: "DataGara",
        label: Trad.Trad("DataGara"),
        options: {
            filter: false,
            sort: false,
            setCellProps: () => ({
                align: "center"
            }),
            customBodyRender: (val: string) => Trad.TradParam("{1-D}", [val])
        }
    },
    {
        name: "DataPresentazione",
        label: Trad.Trad("DataPresentazione"),
        options: {
            filter: false,
            sort: false,
            setCellProps: () => ({
                align: "center"
            }),
            customBodyRender: (val: string) => Trad.TradParam("{1-D}", [val])
        }
    },
    {
        name: "ImportoComplessivo",
        label: Trad.Trad("ImportoComplessivo"),
        options: {
            filter: false,
            sort: false,
            setCellProps: () => ({
                align: "right"
            }),
            customBodyRender: (val: string) => Trad.TradParam("{1-I}", [val])
        }
    },
    {
        name: "OggettoGaranzia",
        label: Trad.Trad("OggettoGaranzia"),
        options: {
            filter: false,
            sort: false,
            setCellProps: () => ({
                align: "center"
            }),
            customBodyRender: (val: string | undefined) => Glob.TagliaStringa(val, 50)
        }
    },
    {
        name: "LuogoEsecuzione",
        label: Trad.Trad("LuogoEsecuzione"),
        options: {
            filter: false,
            sort: false,
            setCellProps: () => ({
                align: "center"
            })
        }
    },
    {
        name: "Modificato",
        label: Trad.Trad("Data"),
        options: {
            filter: false,
            sort: false,
            setCellProps: () => ({
                align: "center"
            }),
            customBodyRender: (val: number) => Trad.TradParam("{1-D}", [val])
        }
    }
];



// WEBPACK FOOTER //
// ./src/inar2/components/Bond/TendersDatabaseColumns.tsx